<script>
  import { RolesStore } from '@/stores/RoleStore';

  export default {
    data() {
      return {
        rolesStore: RolesStore.data,
      };
    },
    methods: {
      async getCurrentUser() {
        try {
          this.$wait.start('loading user');
          const userId = this.$authService.user.id;
          const response = await this.$api.get(`users/${userId}`);
          const currentUser = response.data;
          if (this.$authService.user && this.$authService.user.id === currentUser.id) {
              return currentUser;
          }
          return null;
        } finally {
          this.$wait.end('loading user');
        }
      },
      async getUsers() {
        try {
          this.$wait.start('loading users');
          const response = await this.$api.get(`users`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting users');
        } finally {
          this.$wait.end('loading users');
        }
      },
      async getEntraUsers(searchTerm) {
        try {
          this.$wait.start('loading entra users');
          const response = await this.$api.get(`users/entra?q=${encodeURIComponent(searchTerm)}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting entra users');
        } finally {
          this.$wait.end('loading entra users');
        }
      },
      async getUser(userId) {
        try {
          this.$wait.start('loading user');
          const response = await this.$api.get(`users/${userId}`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting users');
        } finally {
          this.$wait.end('loading user');
        }
      },
      async updateUser(update, toast = true) {
        try {
          this.$wait.start('updating user');
          const response = await this.$api.put(`users/${update.id}`, update);
          if (toast) { this.$toast.success(`'${update.givenName}' updated`); }
          return response;
        } catch (err) {
          if (toast) { this.$toast.error(`Could not update '${update.givenName}'`); }
        } finally {
          this.$wait.end('updating user');
        }
      },
      async removeUser(remove, toast = true) {
        try {
          this.$wait.start('removing user');
          const response = await this.$api.delete(`users/${remove.id}`);
          if (toast) { this.$toast.success(`'${remove.givenName}' removed`); }
          return response;
        } catch (err) {
          if (toast) { this.$toast.error(`Could not remove '${remove.givenName}'`); }
        } finally {
          this.$wait.end('removing user');
        }
      },
      async createUser(create, toast = true) {
        try {
          this.$wait.start('creating user');
          const response = await this.$api.post(`users/${create.id}`, create);
          if (toast) { this.$toast.success(`'${create.givenName}' created`); }
          return response;
        } catch (err) {
          if (toast) { this.$toast.error(`Could not create '${create.givenName}'`); }
        } finally {
          this.$wait.end('creating user');
        }
      },
    },
    computed: {
      roles() {
        return this.rolesStore.roles;
      },
    }
  };
</script>
